import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TitleStateService {
    private readonly _titleSubject = new BehaviorSubject<string>('');
    title$ = this._titleSubject.asObservable();

    setTitle(title: string) {
        this._titleSubject.next(title);
    }
}
